import React from "react";
import "../../styles/loading-spinner.css";
var LoadingSpinner = function LoadingSpinner(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "makroOrange" : _ref$color;
    return /*#__PURE__*/ React.createElement("div", {
        className: "lds-ellipsis"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-" + color
    }), /*#__PURE__*/ React.createElement("div", {
        className: "bg-" + color
    }), /*#__PURE__*/ React.createElement("div", {
        className: "bg-" + color
    }), /*#__PURE__*/ React.createElement("div", {
        className: "bg-" + color
    }));
};
export default LoadingSpinner;
